import { useInfiniteQuery } from "@tanstack/react-query";
import * as api from "@/services/inventory_api";
import type { LibraryItemFilters, SortAxis, SortDir } from "@/services/inventory_types";

export function useInventoryLibraryItems(args: {
  sort?: SortAxis;
  dir?: SortDir;
  filters?: LibraryItemFilters;
}) {
  const sort = args.sort ?? "code";
  const dir = args.dir ?? "asc";
  const filters = args.filters;

  return useInfiniteQuery({
    queryKey: ["inventory", "library-items", { sort, dir, filters }],
    initialPageParam: undefined as string | undefined,
    queryFn: ({ pageParam }) =>
      api.listLibraryItems({ cursor: pageParam, sort, dir, filters }),
    getNextPageParam: (last) => last.next_cursor ?? undefined,
    staleTime: 30_000,
  });
}
